import { render, staticRenderFns } from "./modalCambiarDescuento.vue?vue&type=template&id=629f8e0c&scoped=true&"
import script from "./modalCambiarDescuento.vue?vue&type=script&lang=js&"
export * from "./modalCambiarDescuento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629f8e0c",
  null
  
)

export default component.exports